import styles from './style.module.scss';
import { Divider } from 'antd';
import transitionImg from '@/assets/images/simulation/transition_arrow.webp';
import SimulationImg from '../../../components/SimulationImg';
const CardListOverOne = (props) => {
    let { reportCards = [] } = props;

    return (
        <>
            <div className={styles.eventTimelineWrap}>
                <div data-size="large" className={styles.eventTimeline}>
                    {reportCards.map((ele, index) => {
                        return (
                            index < 3 && (
                                <div key={index} className={styles.flipCard}>
                                    <div className={styles.flipCardInner}>
                                        <div className={styles.flipCardFront}>
                                            <div className={styles['event-index']}>{index > 9 ? index + 1 : '0' + (index + 1)}</div>
                                            <div className={styles['event-title']}>{ele.scenario_title}</div>
                                            <div>
                                                <SimulationImg className={styles['event-img']} src={ele.scenario_image} alt={ele.scenario_title} />
                                            </div>
                                            <div className={styles['event-content']}>{ele.scenario_description}</div>
                                        </div>

                                        <div className={styles.flipCardBack}>
                                            <div className={styles['top']}>
                                                <div className={styles['choice-index']}>
                                                    {index > 9 ? index + 1 : '0' + (index + 1)}
                                                    <div className={styles['choice-title']}>你的选择</div>
                                                </div>

                                                <div className={styles['choice']}>{ele?.choice_path}</div>
                                            </div>

                                            <div className={styles['choice-split-line']}>
                                                <img src={transitionImg} alt={ele.scenario_title} />
                                                <Divider
                                                    style={{
                                                        borderColor: '#D9D9D9',
                                                        marginTop: '6px',
                                                        marginBottom: '12px',
                                                        fontSize: '14px',
                                                        color: '#8C8C8C'
                                                    }}
                                                    dashed
                                                >
                                                    产生影响
                                                </Divider>
                                            </div>
                                            <div className={styles['bottom']}>
                                                <div className={styles['choice-content']}>{ele?.impact_analysis}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
            </div>
        </>
    );
};
export default CardListOverOne;
